import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from './Dashboard';
var App = function () { return (React.createElement(Switch, null,
    React.createElement(Route, { path: "/", component: Dashboard }))); };
export default App;
